<template>
    <div id="main-container" :class="{
        'b-white': $store.state.background_color == 'white',
        'b-black': $store.state.background_color == 'black',
        'b-zouge': $store.state.background_color == 'zouge',
        'b-sakura': $store.state.background_color == 'sakura',
        'b-dreamy': $store.state.background_color == 'dreamy',
        'b-forest': $store.state.background_color == 'forest',
        'b-cosmo': $store.state.background_color == 'cosmo',
        'b-metal': $store.state.background_color == 'metal',
        'b-doom': $store.state.background_color == 'doom',
        'b-rome': $store.state.background_color == 'rome',
        'b-jupiter': $store.state.background_color == 'jupiter',
        'b-space': $store.state.background_color == 'space',
    }">
        <div id="primary-background" class="background"></div>
        <div id="secondary-background" class="background"></div>
        <navigation
            :is-writing="isWriting"
            @showLayout="showLayout(false)"
            @showActivities="showActivities"
            @showSidemenu="showSidemenu"
            @upgraded="upgraded"></navigation>
        <sidemenu
            @showLayout="showLayout(false)"></sidemenu>
        <main>
            <router-view @writing="isWriting = $event" @superReload="superReload()" @showLayout="showLayout" v-slot="{ Component }">
                <transition mode="out-in">
                    <component :is="Component" />
                </transition>
            </router-view>
        </main>
        <foot v-if="hasFooter"></foot>
        <layout :isFull="isFull"></layout>
        <activity></activity>
        <r18></r18>
        <wall-button
            v-if="isReady"
            @showWall="showWall()"
            :unread="unread"
            :ratingWall="ratingWall"
            :isWriting="isWriting"></wall-button>
        <wall @ready="readyWall()" @stop="stopWall()" @unread="unread = $event" @rateWall="rateWall($event)"></wall>
    </div>
</template>

<style lang="scss">
.background {
    content: "";
    pointer-events: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100dvh;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    opacity: 0;
    background-image: none;
    transition: opacity 5s ease-in-out;
}
</style>

<script>
import Navigation from 'components/Navigation'
import Layout from "components/Layout";
import Activity from "components/Activity";
import Sidemenu from "components/Sidemenu";
import WallButton from "components/WallButton";
import Wall from "components/Wall";
export default {
    components: {
        Navigation,
        Layout,
        Activity,
        Sidemenu,
        WallButton,
        Wall
    },
    data() {
        return {
            isWriting: false,
            isFull: true,
            bgIndex: [],
            timer: null,
            place: null,
            backgrounds: [],    // 現在の背景
            portal_backgrounds: null,
            bookshelf_backgrounds: null,
            book_backgrounds: null,
            section_backgrounds: null,
            is_section: false,  // エピソード背景表示中
            book_id: null,      // 現在の小説ID
            section_id: null,   // 現在のエピソードID
            hash: null, // 現在の背景のハッシュ値
            pane: "primary",
            isReady: false,     // 壁準備完了
            ratingWall: null,   // 壁のレーティング
            unread: 0,          // 未読数
        }
    },
    methods: {
        showLayout(is_full = true) {
            this.isFull = is_full;
            setTimeout(() => {
                $("#layout-modal").modal();
            });
        },
        showActivities() {
            $("#activity-modal").modal();
        },
        showSidemenu() {
            $("#sidemenu-modal").modal();
        },
        upgraded() {
            alert.warn("貸し本棚が更新されています。ページをリロードしてください。", null, 90);
        },
        // 背景初期化
        async initBackground() {
            if (this.$isPortal) {
                const res = await axios.get("/portal/backgrounds");
                this.portal_backgrounds = res.data;
            } else {
                const res = await axios.get("/author/backgrounds");
                this.bookshelf_backgrounds = res.data;
            }
            this.reloadBackground();
        },
        // 背景切り替え
        showBackground() {
            if (this.backgrounds && this.backgrounds.length > 0) {
                if (this.bgIndex[this.hash] === undefined || this.backgrounds.length <= this.bgIndex[this.hash]) {
                    this.bgIndex[this.hash] = 0;
                }
                let url = null
                if (this.backgrounds[this.bgIndex[this.hash]].picture) {
                    url = this.backgrounds[this.bgIndex[this.hash]].picture.url;
                } else {
                    url = this.backgrounds[this.bgIndex[this.hash]].url;
                }
                this.bgIndex[this.hash]++;
                const img = new Image();
                img.onload = () => {
                    const currPane = this.pane;
                    this.pane = (this.pane === "primary") ? "secondary": "primary";
                    $("#" + this.pane + "-background").css({
                        "background-image": "url(" +img.src+ ")",
                        "opacity": 0.15
                    });
                    $("#" + currPane + "-background").css({
                        "opacity": 0
                    });
                };
                img.src = url;
            } else if (this.bgIndex[this.hash] > 0) {
                $("#" + this.pane + "-background").css({
                    "opacity": 0,
                });
                this.bgIndex[this.hash] = 0;
            }
        },
        // 背景一覧
        async reloadBackground() {
            let backgrounds = null;
            this.is_section = false;
            if (this.$isPortal) {
                backgrounds = this.portal_backgrounds;
            } else {
                backgrounds = this.bookshelf_backgrounds;
            }
            if (this.place === "book" || this.place === "section") {
                if (this.book_id !== this.$route.params.book_id) {
                    const res = await axios.get("/author/backgrounds/book", {params: {book_id: this.$route.params.book_id}});
                    this.book_backgrounds = res.data;
                    this.book_id = this.$route.params.book_id;
                }
                if (this.book_backgrounds?.length > 0) {
                    backgrounds = this.book_backgrounds;
                }
            }
            if (this.place === "section") {
                const res = await axios.get("/author/backgrounds/section", {params: {section_id: this.$route.params.id}});
                this.section_backgrounds = res.data;
                this.section_id = this.$route.params.id;
                if (this.section_backgrounds?.length > 0) {
                    backgrounds = this.section_backgrounds;
                }
            }

            const hash = await this.sha256(JSON.stringify(backgrounds));
            if (this.hash !== hash) {
                this.backgrounds = backgrounds;
                this.hash = hash;
                if (this.timer) {
                    clearInterval(this.timer);
                }
                this.timer = setInterval(this.showBackground, 1000 * 60 * 5);
                // this.timer = setInterval(this.showBackground, 1000 * 30); // FOR DEBUG
                setTimeout(this.showBackground, 500);
            }
        },
        async sha256(text) {
            if (!crypto.subtle) {
                // insecure環境
                return text;
            }
            const msgUint8 = new TextEncoder().encode(text);
            const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
            return hashHex;
        },
        connectChannel() {
            Echo.channel("public").listen("Alert\\Message", (e) => {
                const title = '管理者より:';
                if (e.type == 'err') {
                    alert.err(e.message, title);
                } else if (e.type == 'warn') {
                    alert.warn(e.message, title);
                } else {
                    alert.msg(e.message, title);
                }
            });
        },
        showWall() {
            if (this.isReady) {
                $("#wall-modal").modal();
            }
        },
        readyWall() {
            this.isReady = true;
        },
        stopWall() {
            this.isReady = false;
        },
        rateWall(rating) {
            this.ratingWall = rating;
        },
    },
    watch: {
        '$route.path'(n, o) {
            if (this.place !== this.where) {
                this.place = this.where;
                this.reloadBackground();
            } else if (this.place === "section" && this.where === "section") {
                this.reloadBackground();
            }
        }
    },
    computed: {
        hasFooter() {
            if (this.$store.state.is_isolated) {
                // 隔離本棚
                return false;
            }
            if (!this.$route.path.match(/\/author\/page|preview|live|notes\/edit|section\/edit|plot|\/jump/)) {
                // 本文ページやプレビュー、ライブ、エディタ以外
                return true;
            }
            return false;
        },
        where() {
            if (this.$route.path.match(/^\/author\/page\/\d+\/section\/\d+/)) {
                // author
                return "section";
            } else if (this.$route.path.match(/^\/mypage\/book\/\d+\/section\/edit\/\d+/)) {
                // mypage
                return "section";
            } else if (this.$route.path.match(/^\/mypage\/book\/\d+/)) {
                // mypage
                return "book";
            } else if (this.$route.path.match(/^\/author\/book\/\d+/)) {
                // author
                return "book";
            }
            return "other";
        },
    },
    mounted() {
        this.place = this.where;
        this.$store.commit("setBackgroundCallback", this.initBackground);
        this.initBackground();
        this.connectChannel();
    },
    beforeRouteLeave(to, from) {
        Echo.leaveChannel("public");
    },
}
</script>